const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      width: '100vw',
      height: '100vh',
      fallbacks: {
        height: 'calc(var(--vh) * 100)',
      },
      // overflow: 'hidden',
    },
    media: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      fontFamily: "'object-fit: cover; object-position: center;'",
    },
    mediaContainer: {
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: theme.getRgba(theme.colors[2], 0.6),
      opacity: 0,
    },
    mediaCrop: {
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 210px)',
      width: 420,
      height: 420,
      transform: 'rotate(6deg)',
      opacity: 0.5,
      zIndex: 0,
    },
    content: {
      extend: theme.wrapper,
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    spacer: {},
    render: {
      '& $mediaCrop': {
        transform: 'rotate(0)',
      },
    },
    pretitle: {
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: 1.5,
      marginBottom: '3vh',
      textTransform: 'uppercase',
      zIndex: 1,
    },
    title: {
      position: 'relative',
      fontFamily: theme.fonts[1],
      fontWeight: 700,
      textTransform: 'uppercase',
      lineHeight: 1.1,
      '& > span': {
        zIndex: 1,
      },
    },
    rightLink: {
      position: 'absolute',
      zIndex: 1,
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      opacity: 0,
    },
    line: {
      height: 1,
      width: '100%',
      display: 'block',
      willChange: 'transform',
      backfaceVisibility: 'hidden',
      zIndex: 1,
      opacity: 0.45,
      transform: 'scaleX(0)',
      transformOrigin: 'left',
    },
    text: {
      marginTop: '3.6vh',
      width: '60%',
      opacity: 0,
      fontSize: 16,
      lineHeight: 1.5,
      zIndex: 1,
    },
    textMobile: {
      opacity: 0,
    },
    cta: {
      marginTop: '12vh',
      opacity: 0,
      zIndex: 1,
    },
    backgroundImage: {},
    backdrop: {
      position: 'absolute',
      pointerEvents: 'none',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
    },
    backgroundDark: {
      color: theme.colors[1],
      '& $backdrop': {
        background: theme.colors[0],
      },
      '& $line': {
        background: theme.colors[1],
      },
    },
    backgroundLight: {
      color: theme.colors[0],
      '& $backdrop': {
        background: theme.colors[1],
      },
      '& $line': {
        background: theme.colors[0],
      },
      '&$render': {
        '& $mediaCrop': {
          opacity: 0.8,
        },
      },
    },
    backgroundRed: {
      color: theme.colors[1],
      '& $backdrop': {
        background: theme.colors[3],
      },
      '&$backgroundImage': {
        color: theme.colors[1],
      },
      '& $line': {
        background: theme.colors[1],
      },
      '& $overlay': {
        mixBlendMode: theme.detect.isIE11 ? 'none' : 'multiply',
        background: theme.colors[3],
      },
    },
    backgroundBlue: {
      color: theme.colors[1],
      '& $backdrop': {
        background: theme.colors[4],
      },
      '& $line': {
        background: theme.colors[1],
      },
      '$ $mediaContainer': {
        '&::after': {
          mixBlendMode: 'multiply',
          opacity: theme.detect.isIE11 ? '0.6' : 1,
          background: theme.colors[4],
        },
      },
      '& $overlay': {
        mixBlendMode: 'exclusion',
        background: theme.colors[4],
      },
    },
    backgroundArt: {
      color: theme.colors[1],
      '& $backdrop': {
        background: theme.colors[8],
      },
      '& $line': {
        background: theme.colors[1],
      },
      '$ $mediaContainer': {
        '&::after': {
          background: theme.colors[8],
        },
      },
      '& $overlay': {
        background: theme.colors[8],
      },
    },
    colorLight: {
      color: theme.colors[1],
    },
    colorDark: {
      color: theme.colors[0],
    },
    colorOlive: {
      color: theme.colors[11],
    },
    fontSizeSm: {
      '& $title': {
        fontSize: 'calc(15px + 2vw)',
      },
    },
    fontSizeMd: {
      '& $title': {
        fontSize: 'calc(40px + 2vw)',
      },
    },
    fontSizeMd2: {
      '& $title': {
        fontSize: 'calc(65px + 2vw)',
      },
    },
    fontSizeLg: {
      '& $title': {
        fontSize: 'calc(52px + 6vw)',
      },
    },
    aboveTheFold: {
      '& $spacer': {
        height: (props) => `${props.headerHeight}px`,
      },
    },
    alignRight: {},
    alignLeft: {},
    textInside: {
      height: (props) => `${props.imageHeight}px`,
      [theme.mediaInverse.sm]: {
        height: 'auto !important',
        minHeight: (props) => `${props.imageHeight}px`,
      },
      marginTop: 150,
      marginBottom: 150,
      '&$alignLeft': {
        '& $mediaCrop': {
          right: '12vw',
          left: 'inherit',
        },
      },
      '&$alignRight': {
        '& $mediaCrop': {
          right: 'inherit',
          left: '12vw',
        },
        '& $title': {
          marginLeft: 'auto',
        },
        '& $pretitle': {
          marginLeft: 'auto',
        },
        '& $text': {
          marginLeft: 'auto',
        },
      },
      '& $mediaCrop': {
        top: 'calc(50% - 300px)',
        width: 600,
        height: 600,
      },
      '& $title': {
        width: '60%',
      },
      '& $pretitle': {
        width: '60%',
        fontSize: 24,
        fontFamily: theme.fonts[1],
        fontWeight: 700,
      },
      '& $text': {
        fontSize: 24,
      },
      '& $line': {
        display: 'none',
      },
    },
    notViewportHeight: {
      height: 'auto',
      paddingTop: 0,
      paddingBottom: 0,
    },
    titleLine: {
      position: 'relative',
      '& span': {
        zIndex: 1,
      },
    },
    entered: {},
    img: {
      opacity: 0,
      transition: `opacity 1s ${theme.easings['power4.out']} 1s`,
      '&$entered': {
        opacity: '1',
      },
    },
    img1: {
      position: 'absolute',
      top: '10vh',
      left: '2vw',
      zIndex: 0,
      width: '35vw',
    },
    img2: {
      position: 'absolute',
      top: '-10vh',
      right: 0,
      zIndex: 0,
      width: '26vw',
    },
  }

  output[theme.mediaInverse.xl] = {
    mediaCrop: {
      top: '-100px',
    },
  }

  output[theme.mediaInverse.md] = {
    mediaCrop: {
      width: 300,
      height: 300,
    },
    text: {
      width: '100%',
    },
  }

  output[theme.mediaInverse.sm] = {
    content: {
      padding: '0 6vw',
    },
    mediaCrop: {
      width: 200,
      height: 200,
    },
    pretitle: {
      fontSize: 12,
    },
    rightLink: {
      position: 'relative',
      zIndex: 1,
      right: 'inherit',
      top: 'auto',
      transform: 'none',
      marginTop: 50,
    },
    fontSizeSm: {
      '& $title': {
        fontSize: 'calc(10px + 2vw)',
      },
    },
    fontSizeMd: {
      '& $title': {
        fontSize: 'calc(20px + 2vw)',
      },
    },
    fontSizeMd2: {
      '& $title': {
        fontSize: 'calc(25px + 2vw)',
      },
    },
    fontSizeLg: {
      '& $title': {
        fontSize: 'calc(30px + 4vw)',
      },
    },
    textMobile: {
      fontSize: 16,
      padding: '0 6vw',
      marginBottom: 100,
    },
    textInside: {
      marginTop: 50,
      marginBottom: 50,
      display: 'flex',
      alignItems: 'center',
      '& $title': {
        width: '100%',
      },
      '& $pretitle': {
        width: '100%',
      },
      '& $text': {
        fontSize: 16,
        display: 'none',
      },
      '& $mediaCrop': {
        top: 'calc(50% - 100px)',
        width: 200,
        height: 200,
      },
      '&$alignRight': {
        '& $mediaCrop': {
          right: '12vw',
          left: 'inherit',
        },
      },
    },
  }

  return output
}

export default style
